import FullWidthLayout from "@/layouts/FullWidthLayout";
import KDriversTable from "kinnect-front/KYard/Drivers/KDriversTable";
import { Broadcastable, FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { VCard, VSheet } from "vuetify/lib";
import { YardDriver } from "kinnect-models";

export default {
	name: "YardDriversPage",

	metaInfo: { title: "Yard - Drivers" },

	mixins: [
		Broadcastable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		drivers: [],
		search: "",
		broadcasts: {
			Model: YardDriver,
			channel: "driver",
			propKey: "drivers",
			eventNames: {
				c: "driver.created",
				u: "driver.updated",
				d: "driver.deleted"
			}
		}
	} ),

	computed: {
		numDrivers() {
			return this.drivers.length;
		},

		toolbarActions() {
			const actions = [];

			if ( this.$can( "add_yard_drivers" ) ) {
				actions.push( {
					icon: "add_circle",
					text: "Add Driver",
					to: { name: "yardDriverAdd" },
					tooltip: "Add a new driver"
				} );
			}

			if ( this.$can( "edit_yard_drivers" ) ) {
				actions.push( {
					icon: "event",
					text: "View Time Off",
					to: { name: "yardDriversTimeOff" },
					tooltip: "View time off for all drivers"
				} );
			}

			return actions;
		}
	},

	watch: {
		numDrivers( numDrivers ) {
			this.$store.dispatch( "breadcrumbs/setDetails", `${numDrivers} drivers` );
		}
	},

	methods: {
		async fetchDrivers() {
			this.drivers = await YardDriver.get();
		},

		async fetch() {
			await this.fetchDrivers();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<KDriversTable
					items={this.drivers}
					loading={this.$wait.is( "get drivers" )}
					search={this.search}
				></KDriversTable>
			</VCard>
		</FullWidthLayout>;
	}
};
